function blogNavigation() {
	const select = document.querySelector('#blog-nav');

	if (!select) return;

	select.addEventListener('change', (e) => {
		if (e.target.value.trim().length) {
			window.location.href = e.target.value;
		}
	});
}

function scrollOnRefresh() {
	if (window.location.hash === '#filtered') {
		setTimeout(() => {
			const articles = document.querySelector('#articles');

			if (!articles) return;

            const articlesRect = articles.getBoundingClientRect();

            if (articlesRect.top == window.pageYOffset) return;

            const header = document.querySelector('header.header');

			window.scrollTo({
				top: articlesRect.top - (header.getBoundingClientRect().height + 30),
				behavior: 'smooth',
			});
		}, 500);
	}
}

export default function blog() {
	blogNavigation();
    scrollOnRefresh();
}
